/* Subumi console-picker guard.
   Pills render unchecked unless a variant is explicit in the URL
   (see snippets/product-variant-options.liquid). Until the buyer picks a
   console model, keep the product form's buttons disabled and show a
   direct helper line. Progressive enhancement: without JS, Dawn's default
   first-available-variant behaviour applies. */
(function () {
  var HELPER_TEXT = window.subumiVariantHelperText || 'Pick a console model first.';

  function initGuard(picker) {
    var section = picker.closest('section, .shopify-section') || document;
    var radios = picker.querySelectorAll(".product-form__input--pill input[type='radio']");
    if (!radios.length) return;

    var forms = section.querySelectorAll('product-form form, form[data-type="add-to-cart-form"]');
    if (!forms.length) return;

    function hasSelection() {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return true;
      }
      return false;
    }

    function setDisabled(disabled) {
      forms.forEach(function (form) {
        var buttons = form.querySelectorAll('button[type="submit"], .shopify-payment-button button');
        buttons.forEach(function (btn) {
          if (disabled) {
            btn.setAttribute('disabled', 'disabled');
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
          }
        });
        var helper = form.parentElement.querySelector('.subumi-variant-helper');
        if (disabled && !helper) {
          helper = document.createElement('p');
          helper.className = 'subumi-variant-helper';
          helper.setAttribute('role', 'status');
          helper.textContent = HELPER_TEXT;
          form.parentElement.insertBefore(helper, form);
        } else if (!disabled && helper) {
          helper.remove();
        }
      });
    }

    if (!hasSelection()) {
      setDisabled(true);
      picker.addEventListener('change', function onPick() {
        if (hasSelection()) {
          setDisabled(false);
          picker.removeEventListener('change', onPick);
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(initGuard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
